import Vue from 'vue';
import Vuex from 'vuex';

import state from './store/state';
import mutations from './store/mutations';
import actions from './store/actions';

import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

const badMutations = [
    'snackBar',
    'confirm',
    'info'
];

const vuexLocalStorage = new VuexPersist({
    key: 'vuex', // The key to store the state on in the storage provider.
    storage: window.localStorage, // or window.sessionStorage or localForage
    // Function that passes the state and returns the state with only the objects you want to store.
    // reducer: state => state,
    reducer: state => ({
        user: state.user,
        dancers: state.dancers,
        starterTemplates: state.starterTemplates,
        starterTypes: state.starterTypes,
        starterStyles: state.starterStyles,
        //events: state.events,
        eventTypes: state.eventTypes,
        registrations: state.registrations,
        users: state.users,
        cache: state.cache
        // getRidOfThisModule: state.getRidOfThisModule (No one likes it.)
    })
    // Function that passes a mutation and lets you decide if it should update the state in localStorage.
    //filter: mutation => (badMutations.indexOf(mutation.type) === -1)
});

export default new Vuex.Store({
    state,
    mutations,
    actions,
    plugins: [vuexLocalStorage.plugin]
});